import { onGetUserInfo } from "@/api/common"
import { persistOptions } from "@/store/_persist"
import { defineStore } from "pinia"

const INITIAL_USER_INFO = {
  nickname: "",
  avatar: "",
  openid: "",
  role: "user",
}

export const useUserStore = defineStore("user", {
  state: () => ({
    userInfo: { ...INITIAL_USER_INFO },
    token: /** @type {string | null} */ (null),
  }),

  getters: {
    isLogin: (state) => Boolean(state.token),
    getToken: (state) => state.token,
    userRole: (state) => state.userInfo.role,
  },

  actions: {
    async onLogin() {
      throw new Error(
        "useUserStore.onLogin 尚未接入业务接口，请在 store 中实现",
      )
    },
    setToken(value) {
      this.token = value
    },
    async setUserInfo() {
      const result = await onGetUserInfo()
      if (result.code === 200) {
        this.userInfo = result.data
      }
    },
    setBasicUserInfo(payload) {
      this.userInfo = { ...this.userInfo, ...payload }
    },
    clearUserInfo() {
      this.userInfo = { ...INITIAL_USER_INFO }
      this.token = null
    },
    setUserRole(role) {
      this.userInfo.role = role
    },
  },

  persist: persistOptions("user-store"),
})
